import { useState, useCallback, ReactNode } from 'react'
import { ModulesContext } from '../hooks/useModules'

export function ModulesProvider({ children }: { children: ReactNode }) {
  const [enabledModules, setEnabledModulesState] = useState<Record<string, boolean>>({})
  const [modulesLoaded, setModulesLoaded] = useState(false)

  // Automatically marks modules as loaded whenever they are set (success or fallback)
  const setEnabledModules = useCallback((modules: Record<string, boolean>) => {
    setEnabledModulesState(modules)
    setModulesLoaded(true)
  }, [])

  const disableModule = useCallback((name: string) => {
    setEnabledModulesState((prev) => ({ ...prev, [name]: false }))
  }, [])

  return (
    <ModulesContext.Provider
      value={{ enabledModules, modulesLoaded, setEnabledModules, disableModule }}
    >
      {children}
    </ModulesContext.Provider>
  )
}
